

import Vue from "vue";

//import Home from "./views/Home.vue";

export default Vue.extend({
    name: "App",

    components: {
        //Home
    },

    data: () => ({
        drawer: false,
        updateAvailable: false,
        swRegistration: null as ServiceWorkerRegistration | null,
        reloading: false,
        updateDismissed: false,
        versaoPendente: '' as string,
    }),

    created() {
        window.addEventListener('onix-sw-updated', this.onServiceWorkerUpdated as unknown as EventListener);

        if (navigator.serviceWorker) {
            navigator.serviceWorker.addEventListener('controllerchange', () => {
                this.recarregarUmaVez();
            });
        }
    },

    beforeDestroy() {
        window.removeEventListener('onix-sw-updated', this.onServiceWorkerUpdated as unknown as EventListener);
    },

    methods: {
        open: function () {
            this.$data.drawer = !this.$data.drawer;
        },

        async onServiceWorkerUpdated(event: CustomEvent) {
            // Dispensado nesta sessao: nao reabre ate a proxima versao
            if (this.updateDismissed || this.avisoAtualizacaoSuprimido()) return;

            const registration = event.detail as ServiceWorkerRegistration;

            // O scriptURL e sempre /service-worker.js, entao nao distingue
            // versoes. O conteudo do worker cita os arquivos com hash do build,
            // entao usamos ele como identificador.
            const versao = await this.identificarVersao();

            if (versao && this.versaoJaDispensada(versao)) return;

            this.versaoPendente = versao;
            this.swRegistration = registration;
            this.updateAvailable = true;
        },

        // Le o proprio service-worker.js: como ele lista os arquivos do app
        // (que tem hash no nome), o conteudo muda a cada publicacao.
        async identificarVersao(): Promise<string> {
            try {
                const resposta = await fetch('/service-worker.js', { cache: 'no-store' });
                const texto = await resposta.text();

                // Guarda so um resumo: o localStorage nao precisa do arquivo todo
                let hash = 0;
                for (let i = 0; i < texto.length; i++) {
                    hash = ((hash << 5) - hash + texto.charCodeAt(i)) | 0;
                }

                return String(hash);
            } catch (error) {
                return '';
            }
        },

        avisoAtualizacaoSuprimido(): boolean {
            try {
                const suprimidoAte = Number(window.localStorage.getItem('onix-atualizacao-suprimida-ate') || 0);
                return suprimidoAte > Date.now();
            } catch (error) {
                return false;
            }
        },

        suprimirAvisoAtualizacao() {
            try {
                window.localStorage.setItem('onix-atualizacao-suprimida-ate', String(Date.now() + 10 * 60 * 1000));
            } catch (error) {
                // Navegador sem localStorage: fica apenas a trava em memoria
            }
        },

        // Recarregar a pagina zera o estado do componente, entao a marca fica
        // no navegador. O logout limpa a chave e o aviso volta a aparecer.
        versaoJaDispensada(versao: string): boolean {
            try {
                return window.localStorage.getItem('onix-versao-dispensada') === versao;
            } catch (error) {
                return false;
            }
        },

        marcarVersaoDispensada() {
            try {
                if (this.versaoPendente) {
                    window.localStorage.setItem('onix-versao-dispensada', this.versaoPendente);
                }
                this.suprimirAvisoAtualizacao();
            } catch (error) {
                // Navegador sem localStorage: o aviso volta na proxima carga
            }
        },

        dismissUpdate() {
            this.updateAvailable = false;
            this.updateDismissed = true;
            this.marcarVersaoDispensada();
        },

        applyUpdate() {
            this.updateAvailable = false;
            this.updateDismissed = true;
            this.marcarVersaoDispensada();

            const waiting = this.swRegistration && this.swRegistration.waiting;

            if (!waiting) {
                this.recarregarUmaVez();
                return;
            }

            // Se o worker ativar mas o controllerchange nao disparar (acontece
            // quando a aba nunca teve controlador), recarregamos por aqui.
            waiting.addEventListener('statechange', () => {
                if (waiting.state === 'activated') this.recarregarUmaVez();
            });

            try {
                waiting.postMessage({ type: 'SKIP_WAITING' });
            } catch (error) {
                console.warn('Nao foi possivel ativar o service worker automaticamente.', error);
                this.recarregarUmaVez();
                return;
            }

            // Mensagem perdida ou rede lenta: nao deixa a pessoa presa no clique
            setTimeout(() => this.recarregarUmaVez(), 3000);
        },

        recarregarUmaVez() {
            if (this.reloading) return;

            this.reloading = true;
            window.location.reload();
        }
    },
});
